import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { useGetAsyncJobQuery } from '@app/features/asyncJobs/asyncJobsApiSlice';
import { setAsyncJob, selectActiveJobs } from '@app/features/asyncJobs/asyncJobsSlice';

const POLLING_INTERVAL = 3000;

interface JobPollerProps {
  jobId: number;
}

const JobPoller = ({ jobId }: JobPollerProps) => {
  const dispatch = useAppDispatch();
  const job = useAppSelector(state => state.asyncJobs[jobId]);
  
  const { data } = useGetAsyncJobQuery(jobId, {
    pollingInterval: POLLING_INTERVAL,
    skip: !job || job.status === 'completed' || job.status === 'failed' || job.status === 'cancelled',
  });

  useEffect(() => {
    if (data && job && (data.status !== job.status || data.progress !== job.progress)) {
      dispatch(setAsyncJob(data));
    }
  }, [data, dispatch, job]);

  return null;
};

export const useAsyncJobsPolling = () => {
  const activeJobs = useAppSelector(selectActiveJobs);
  return { activeJobs, JobPoller };
};

export default useAsyncJobsPolling;
